import styled from 'styled-components';

export const Item = styled.div`
  text-align: center;
  margin-left: 1px;
`;

export const Value = styled.div`
  width: 28px;
  border-radius: 3px;
  border: 1px solid #89898b;
  padding: 4px 0px;
  background: ${(props) => (props.$active ? '#5c8c5e' : '#757577')};
`;

export const Title = styled.div`
  color: #222;
  font-weight: bold;
  font-size: 11px;
  line-height: 1;
`;
